import { useEffect, useRef } from 'react';

const useTimeout = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef<() => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const timeoutId = setTimeout(() => {
        if (savedCallback.current) savedCallback.current();
      }, delay * 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [delay]);
};

export { useTimeout };
